<script>
import { HorizontalBar } from 'vue-chartjs'

function formatCurrency (value) {
  return (new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })).format(value)
}

function formatNumber (value) {
  return (new Intl.NumberFormat('en-US')).format(value)
}

export default {
  extends: HorizontalBar,
  props: {
    receivers: {
      type: Array,
      required: true
    },
    property: {
      type: String,
      required: true
    }
  },
  data () {
    const vm = this

    return {
      chartdata: {
        labels: [],
        datasets: [
          {
            label: '',
            data: [],
            backgroundColor: '#118ab2',
            borderColor: 'white',
            borderWidth: 0
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        tooltips: {
          intersect: false,
          displayColors: false,
          mode: 'index',
          callbacks: {
            title: function (tooltipItems, data) {
              return data.labels[tooltipItems[0].index]
            },
            label: function (tooltipItems, data) {
              const datasetLabel = data.datasets[tooltipItems.datasetIndex].label

              let labelLeft = datasetLabel[0].toUpperCase() + datasetLabel.substring(1) + ': '
              let labelRight = tooltipItems.xLabel

              if (datasetLabel === 'weight') {
                labelRight = formatNumber(labelRight) + 'kg'
              } else if (datasetLabel === 'volume') {
                labelRight = formatNumber(labelRight) + 'm3'
              } else if (datasetLabel === 'consignments') {
                labelRight = formatNumber(labelRight)
              } else if (datasetLabel === 'items') {
                labelRight = formatNumber(labelRight)
              } else if (datasetLabel === 'cost') {
                labelRight = formatCurrency(labelRight)
              }

              return labelLeft + labelRight
            }
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function (value) {
                  return value.substr(0, 15) + (value.length > 15 ? '...' : '')
                }
              }
            }
          ],
          xAxes: [
            {
              ticks: {
                minRotation: 45,
                beginAtZero: true,
                callback: function (value) {
                  let label = value

                  if (vm.property === 'weight') {
                    label = formatNumber(label) + 'kg'
                  } else if (vm.property === 'volume') {
                    label = formatNumber(label) + 'm3'
                  } else if (vm.property === 'consignments') {
                    label = formatNumber(label)
                  } else if (vm.property === 'items') {
                    label = formatNumber(label)
                  } else if (vm.property === 'cost') {
                    label = formatCurrency(label).slice(0, -3)
                  }

                  return label
                }
              }
            }
          ]
        }
      }
    }
  },
  watch: {
    property () {
      this.calculateChart()
      this.renderChart(this.chartdata, this.options)
    }
  },
  mounted () {
    this.calculateChart()
    this.renderChart(this.chartdata, this.options)
  },
  methods: {
    calculateChart () {
      const property = this.$props.property
      const receivers = (JSON.parse(JSON.stringify(this.$props.receivers)))
        .sort((a, b) => parseFloat(b[property]) - parseFloat(a[property]))
        .slice(0, 10)

      this.chartdata.labels = receivers.map(d => d.label.toUpperCase())
      this.chartdata.datasets[0].label = property
      this.chartdata.datasets[0].data = receivers.map(d => d[property])
    }
  }
}
</script>
